export default "__VITE_ASSET__Bz2eXItr__"